import { render, staticRenderFns } from "./DowngradeUnavailableModal.vue?vue&type=template&id=52d386fd"
import script from "./DowngradeUnavailableModal.vue?vue&type=script&lang=js"
export * from "./DowngradeUnavailableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports